import React from 'react';
import { Box, Heading, HStack, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import TourModeActionButton from './TourModeActionButton';

const OrganizationDetailHeader = ({ title, subtitle, actions = [] }) => (
  <HStack justify="space-between" align={{ base: 'start', md: 'center' }} mb={4} flexWrap="wrap" spacing={3}>
    <Box>
      <Heading size="lg">{title}</Heading>
      {subtitle ? <Text color="gray.500">{subtitle}</Text> : null}
    </Box>
    <HStack flexWrap="wrap" spacing={2}>
      {actions.map((action) => (
        action.iconOnly ? (
          <Tooltip key={action.key || action.label} label={action.tooltip || action.label} hasArrow>
            <IconButton
              as={action.to ? RouterLink : undefined}
              to={action.to}
              onClick={action.onClick}
              icon={action.icon || action.leftIcon}
              aria-label={action.ariaLabel || action.label}
              title={action.ariaLabel || action.label}
              variant={action.variant || 'outline'}
              colorScheme={action.colorScheme}
              isDisabled={action.isDisabled}
              size={action.size || 'sm'}
            />
          </Tooltip>
        ) : (
          <TourModeActionButton
            key={action.key || action.label}
            as={action.to ? RouterLink : undefined}
            to={action.to}
            onClick={action.onClick}
            leftIcon={action.leftIcon}
            variant={action.variant || 'outline'}
            colorScheme={action.colorScheme}
            isTour={action.isTour}
            isDisabled={action.isDisabled}
            size={action.size || 'md'}
          >
            {action.label}
          </TourModeActionButton>
        )
      ))}
    </HStack>
  </HStack>
);

export default OrganizationDetailHeader;
